<script>
import StoreSearchForm from '@phoenix/mixins/components/store/StoreSearchForm';
import { mapState } from 'vuex';
import { PhxAutocomplete, PhxIcon } from '@phx-styleguides/rdu';

export default {
  components: {
    PhxAutocomplete,
    PhxIcon,
  },

  mixins: [StoreSearchForm],

  props: {
    displayPositionButton: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    ...mapState('storeSearch', ['placeSuggestions']),

    formattedPlaceSuggestions() {
      return this.placeSuggestions.map((suggestion) => ({
        value: suggestion.suggestion,
        key: suggestion.key,
      }));
    },
  },

  methods: {
    onQuery(query) {
      this.onKeywordInput({ query });
    },
  },
};
</script>

<template>
  <div class="sgphx">
    <div v-if="displayPositionButton">
      <button
        ref="positionBtn"
        type="button"
        class="sgphx-btn sgphx-btn--primary sgphx-btn--positive sgphx-btn--icon"
        @click.prevent="useMyPosition"
      >
        <span class="sgphx-btn__icon sgphx-btn__icon--start">
          <phx-icon icon="store-locator" class="sgphx-icon sgphx-icon--store-locator sgphx-icon--sm" />
        </span>
        <span class="sgphx-btn__text">
          <span>{{ $t('StoreSearch.useMyPosition') }}</span>
        </span>
      </button>

      <div class="h6 my-8">{{ $t('StoreSearch.OR') }}</div>
    </div>

    <phx-autocomplete
      :id="inputKeywordId"
      name="search-stores"
      open-button-icon="search"
      clear-button-icon="close"
      :label="label"
      :placeholder="placeholder"
      :options="formattedPlaceSuggestions"
      hide-label
      data-cy="store-search-form"
      @autocomplete:query="onQuery"
      @autocomplete:change="onSubmit"
    />
  </div>
</template>
